import { useMemo } from "react";
import { WebcastEntry } from "@kaltura/mediaspace-shared-types";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import {
    convertToScheduledSessions,
    EventList,
    EventListContainer,
} from "@kaltura/mediaspace-shared-event-platform-event-list";

export interface SessionsTabProps {
    liveSessions: WebcastEntry[];
}

export function SessionsTab({ liveSessions }: SessionsTabProps) {
    const config = useConfig();
    const { dateFormats } = config.application;

    // set start date label on all sessions
    const scheduledSessions = useMemo(
        () => convertToScheduledSessions(liveSessions, dateFormats.longDateNoYear),
        [liveSessions, dateFormats.longDateNoYear]
    );

    return <EventListContainer sessions={scheduledSessions} eventListComponent={EventList} />;
}

export default SessionsTab;
